import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
} from "../../Actions/types";

const initialState = {
  loader: false,
  error: false,
  data: null,
};
function changePasswordReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_PASSWORD:
      return { ...state, data: action?.payload, loader: true };
    case CHANGE_PASSWORD_SUCCESS:
      return { ...state, data: action?.payload?.data, loader: false };
    case CHANGE_PASSWORD_FAILURE:
      return { ...state, error: true, loader: false };

    default:
      return state;
  }
}

export default changePasswordReducer;
